/* eslint-disable react/no-multi-comp */
import { t } from 'i18next';

import { getSubStepValues } from '#models/general/steps';
import { FIVE_NUMBERS_W1_DECIMAL_REGEX, FROM_0_TO_999_W1_DECIMAL_REGEX } from '#utils/string/regex';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import Input from '#components/general/Input';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';

import { MASHING_AND_COLLECTION_FIELDS, MASH_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

export const getMashingTable = ({ values, errors }) => {
  const getMashingAndCollectionValues = getSubStepValues(
    MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION,
    values,
    errors
  );
  return [
    {
      key: 'firstRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mashingAndCollectionTableColumns,
      fields: [
        {
          key: 'firstWaterNo',
          Component: () => (
            <span className={styles.waterNumber}>
              {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:first`)}
            </span>
          )
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.FIRST_WATER_SPROUT_TEMP, false),
          Component: Input,
          measure: MEASURE_TYPES.TEMPERATURE,
          needsRegex: true,
          customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.FIRST_WATER_LITRES, false),
          Component: Input,
          measure: MEASURE_TYPES.LITRES,
          needsRegex: true,
          customRegex: FIVE_NUMBERS_W1_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.FIRST_TIME_MASH_IN, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.SETTLING_TIME, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.RECIRCULATION_TIME, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.FIRST_START_DRAIN_TIME, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          key: 'blankSpace',
          Component: () => <div />
        }
      ]
    },
    {
      key: 'secondRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mashingAndCollectionTableColumns,
      fields: [
        {
          key: 'secondWaterNo',
          Component: () => (
            <span className={styles.waterNumber}>
              {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:second`)}
            </span>
          )
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.SECOND_WATER_SPROUT_TEMP, false),
          Component: Input,
          measure: MEASURE_TYPES.TEMPERATURE,
          needsRegex: true,
          customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.SECOND_WATER_LITRES, false),
          Component: Input,
          measure: MEASURE_TYPES.LITRES,
          needsRegex: true,
          customRegex: FIVE_NUMBERS_W1_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.SECOND_TIME_MASH_IN, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          key: 'blankSpace1',
          Component: () => <div />
        },
        {
          key: 'blankSpace2',
          Component: () => <div />
        },
        {
          key: 'blankSpace',
          Component: () => <div />
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.SECOND_TIME_DRAINED, false),
          Component: Input,
          type: 'time',
          noMargin: true
        }
      ]
    },
    {
      key: 'thirdRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mashingAndCollectionTableColumns,
      fields: [
        {
          key: 'thirdWaterNo',
          Component: () => (
            <span className={styles.waterNumber}>
              {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:third`)}
            </span>
          )
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.THIRD_WATER_SPROUT_TEMP, false),
          Component: Input,
          measure: MEASURE_TYPES.TEMPERATURE,
          needsRegex: true,
          customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.THIRD_WATER_LITRES, false),
          Component: Input,
          measure: MEASURE_TYPES.LITRES,
          needsRegex: true,
          customRegex: FIVE_NUMBERS_W1_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.THIRD_TIME_MASH_IN, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          key: 'blankSpace1',
          Component: () => <div />
        },
        {
          key: 'blankSpace2',
          Component: () => <div />
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.THIRD_START_DRAIN_TIME, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.THIRD_TIME_DRAINED, false),
          Component: Input,
          type: 'time',
          noMargin: true
        }
      ]
    }
  ];
};
